<template>
	<h4>Sistem Penerimaan Murid Baru {{ ta.nama }}</h4>
	<div class="card shadow">
		<div class="card-header">
			<div class="row row-cols-auto justify-content-between mb-2">
				<div class="col-12 col-md-auto d-inline-flex">
					<h5 class="my-auto">Data Pembayaran Daftar Ulang</h5>
				</div>
				<div v-if="adminKhusus" class="col-auto d-inline-flex">
					<select class="form-select form-select-sm shadow-sm my-auto" v-model="ta">
						<option v-for="t in listTa" :key="t" :value="t">{{ t.nama }}</option>
					</select>
				</div>
				<div v-else class="col-auto d-inline-flex">
					<h6 class="bg-white rounded px-2 py-1 shadow my-auto">{{ ta.nama }}</h6>
				</div>
			</div>
			<div class="row g-1">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<v-select class="bg-white rounded shadow" v-model="petugas_keuangan" placeholder="Petugas Keuangan" label="nama" :options="listKeuangan">
						<template #search="{ attributes, events }">
							<input class="vs__search" v-bind="attributes" v-on="events" />
						</template>
						<template #no-options> Petugas Keuangan tidak ditemukan. </template>
					</v-select>
				</div>
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<v-select class="bg-white rounded shadow" v-model="teller" placeholder="Petugas Pendaftaran" label="nama_petugas" :options="listTeller">
						<template #search="{ attributes, events }">
							<input class="vs__search" v-bind="attributes" v-on="events" />
						</template>
						<template #no-options> Petugas Pendaftaran tidak ditemukan. </template>
					</v-select>
				</div>
			</div>
		</div>
		<div class="card-body">
			<div class="row mb-2">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3 ms-auto">
					<input id="cari" type="search" class="form-control form-control-sm shadow-sm" placeholder="Cari . . ." v-model="key" @keyup="search" @search="search" />
				</div>
			</div>
			<div class="table-responsive vl-parent shadow" ref="dataPembayaran">
				<table class="table table-sm mb-0 text-nowrap">
					<thead class="table-secondary align-middle">
						<tr>
							<th>#</th>
							<th class="position-sticky start-0">No. Reg.</th>
							<th>Nama</th>
							<th>Jurusan</th>
							<th>Jalur</th>
							<th>Nominal</th>
							<th>Petugas Keuangan</th>
							<th>Dibuat</th>
							<th>Diperbarui</th>
							<th>Tindakan</th>
						</tr>
					</thead>
					<tbody v-if="dataPembayaran.length">
						<tr v-for="(d, index) in dataPembayaran" :key="d">
							<td>{{ (index += 1 + pageOffset) }}</td>
							<td class="position-sticky start-0">
								{{ d.no_reg }}
							</td>
							<td>{{ d.nama }}</td>
							<td>{{ d.kode }}</td>
							<td>{{ d.jalur_pendaftaran }}</td>
							<td>
								<transition name="fade" mode="out-in">
									<div :key="d.nominal" class="d-flex justify-content-between gap-1 fw-semibold">
										<span>Rp</span><span>{{ d.nominal.toLocaleString("id-ID") }}</span>
									</div>
								</transition>
							</td>
							<td>
								<div class="hstack gap-1 justify-content-between">
									<transition name="fade" mode="out-in">
										<span :key="d.nama_petugas_keuangan">{{ d.nama_petugas_keuangan }}</span>
									</transition>
									<button
										v-if="d.foto_bukti"
										type="button"
										class="btn btn-sm btn-outline-secondary d-flex border-0"
										@click="getDataPembayaranEdit(d, 'buktiModal')"
										v-tooltip="'Lihat Bukti'">
										<svg xmlns="http://www.w3.org/2000/svg" width="13" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
											<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
											<path
												d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
										</svg>
									</button>
								</div>
							</td>
							<td>
								<div class="fw-bold">{{ d.creator }}</div>
								<small class="fst-italic">{{ d.created_at }}</small>
							</td>
							<td>
								<transition name="fade" mode="out-in">
									<div class="fw-bold" :key="d.editor">{{ d.editor || "-" }}</div>
								</transition>
								<transition name="fade" mode="out-in">
									<small class="fst-italic" :key="d.updated_at">{{ d.updated_at }}</small>
								</transition>
							</td>
							<td>
								<div class="hstack gap-1">
									<button type="button" class="btn btn-sm btn-outline-secondary d-flex" @click="cetak(d)" v-tooltip="'Cetak Bukti Pembayaran'">
										<svg xmlns="http://www.w3.org/2000/svg" width="13" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
											<path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
											<path
												d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
										</svg>
									</button>
									<div class="vr"></div>
									<button type="button" class="btn btn-sm btn-outline-primary d-flex" @click="getDataPembayaranEdit(d, 'editModal')" v-tooltip="'Edit Data'">
										<svg xmlns="http://www.w3.org/2000/svg" width="13" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
											<path
												d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
											<path
												fill-rule="evenodd"
												d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
										</svg>
									</button>
									<div class="vr"></div>
									<button type="button" class="btn btn-sm btn-outline-danger d-flex" @click="confirmDelete(d)" v-tooltip="'Hapus Data'">
										<svg xmlns="http://www.w3.org/2000/svg" width="13" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
											<path
												d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
										</svg>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td class="text-center fst-italic py-3" colspan="11">Data tidak ditemukan.</td>
						</tr>
					</tbody>
				</table>
			</div>
			<span v-if="dataPembayaran.length" class="small text-muted fst-italic">
				Menampilkan {{ pageOffset + 1 }}-{{ pageOffset + dataPembayaran.length }} dari total {{ count }} data
			</span>
		</div>
		<div v-if="dataPembayaran.length" class="card-footer">
			<div class="row row-cols-auto justify-content-sm-between justify-content-center">
				<div class="row row-cols-auto">
					<label class="col-auto col-form-label-sm pe-1" for="numRows">Tampilkan:</label>
					<div class="col-auto ps-1">
						<select class="form-select form-select-sm shadow" v-model="pageLimit" id="numRows">
							<option v-for="l in arrayLimit" :key="l" :value="l">{{ l }} baris</option>
						</select>
					</div>
				</div>
				<div class="col-auto">
					<ul class="pagination pagination-sm shadow mb-0">
						<li class="page-item">
							<button class="page-link" :class="{ disabled: pageCurrent == 1 }" @click="pageCurrent > 1 ? pageCurrent-- : ''">&laquo;</button>
						</li>
						<li class="page-item" v-for="p in pageCount" :key="p">
							<button v-if="p == pageCurrent" class="page-link active fw-bold">{{ p }}</button>
							<button v-else-if="p == 1 || p == pageCount || Math.abs(p - pageCurrent) == 1" class="page-link" @click="pageCurrent = p">{{ p }}</button>
							<button
								v-else-if="(Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) < 5) || (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) < 5)"
								class="page-link"
								@click="pageCurrent = p">
								{{ p }}
							</button>
							<button
								v-else-if="(Math.abs(p - 1) == 5 || Math.abs(p - pageCount) == 5) && (Math.abs(p - pageCount) == 1 || Math.abs(p - 1) == 1)"
								class="page-link"
								@click="pageCurrent = p">
								{{ p }}
							</button>
							<button
								v-else-if="
									Math.abs(p - pageCurrent) == 2 ||
									(Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) == 5) ||
									(Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) == 5)
								"
								class="page-link px-1"
								@click="pageCurrent = p">
								...
							</button>
						</li>
						<li class="page-item">
							<button class="page-link" :class="{ disabled: pageCurrent == pageCount }" @click="pageCurrent < pageCount ? pageCurrent++ : ''">&raquo;</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="modal fade" id="editModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<legend class="modal-title">Edit Data Pembayaran</legend>
						<button type="button" id="tutupFormEdit" class="btn-close" data-bs-dismiss="modal"></button>
					</div>
					<form @submit.prevent="updateData">
						<div class="card-body vl-parent" ref="formEditPembayaran">
							<div class="row mb-2">
								<label class="col-sm-5 col-md-4 col-lg-3 col-form-label col-form-label-sm">Pendaftar</label>
								<div class="col-sm-7 col-lg-5">
									<div class="form-control form-control-sm form-control-plaintext">
										<strong>({{ dataAwal.no_reg }})</strong> {{ dataAwal.nama }}
									</div>
								</div>
							</div>
							<div class="row mb-2">
								<label class="col-sm-5 col-md-4 col-lg-3 col-form-label col-form-label-sm">Nominal</label>
								<div class="col-sm-7 col-lg-5">
									<input
										type="text"
										class="form-control form-control-sm shadow"
										placeholder="Nominal Pembayaran"
										v-model="formEdit.input_nominal"
										required
										pattern="^(Rp\s)(\d{1,3}(?:\.\d{3})+)"
										title="Nominal pembayaran" />
								</div>
							</div>
							<div class="row mb-2">
								<label class="col-sm-5 col-md-4 col-lg-3 col-form-label col-form-label-sm">Jenis Pembayaran</label>
								<div class="col-sm-7 col-lg-5">
									<div class="btn-group btn-group-sm shadow rounded-pill">
										<input type="radio" class="btn-check" v-model="formEdit.jenis_bayar" name="jenis_bayar" value="tunai" id="tunai" autocomplete="off" required />
										<label class="btn btn-outline-primary rounded-start-pill px-3" for="tunai">Tunai</label>
										<input type="radio" class="btn-check" v-model="formEdit.jenis_bayar" name="jenis_bayar" value="transfer" id="transfer" autocomplete="off" />
										<label class="btn btn-outline-primary rounded-end-pill px-3" for="transfer">Transfer</label>
									</div>
								</div>
							</div>
							<div class="row" v-if="formEdit.jenis_bayar === 'tunai'">
								<label class="col-sm-5 col-md-4 col-lg-3 col-form-label col-form-label-sm">Petugas Keuangan</label>
								<div class="col-sm-7 col-lg-5">
									<v-select
										class="bg-white rounded shadow"
										v-model="formEdit.petugas_keuangan"
										placeholder="Petugas Keuangan"
										label="nama"
										:options="listKeuangan.filter((pk) => !pk.transfer)">
										<template #search="{ attributes, events }">
											<input class="vs__search" :required="!formEdit.petugas_keuangan" v-bind="attributes" v-on="events" />
										</template>
										<template #no-options> Petugas Keuangan tidak ditemukan. </template>
									</v-select>
								</div>
							</div>
							<div class="row" v-else-if="formEdit.jenis_bayar === 'transfer'">
								<label class="col-sm-5 col-md-4 col-lg-3 col-form-label col-form-label-sm">Unggah Bukti</label>
								<div class="col-sm-7 col-lg-5">
									<div class="input-group input-group-sm shadow">
										<input
											type="file"
											ref="fieldBuktiBayar"
											class="form-control form-control-sm"
											accept="image/*"
											@change="handleInputBukti"
											:required="!formEdit.fileBuktiBayar"
											:disabled="formEdit.sedangInputBukti" />
										<span class="input-group-text" v-if="formEdit.sedangInputBukti">
											<span class="spinner-border spinner-border-sm text-secondary"></span>
										</span>
									</div>
									<img
										v-if="formEdit.previewBuktiBayar"
										:src="formEdit.previewBuktiBayar"
										style="max-width: 100%; max-height: 200px"
										class="mt-2 shadow btn btn-outline-secondary p-1"
										alt="Bukti Transfer"
										@click="lihatBukti"
										v-tooltip="'Lihat Foto'" />
								</div>
							</div>
						</div>
						<div class="card-footer d-flex justify-content-end">
							<input type="submit" class="btn btn-primary px-4" value="Perbarui" />
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="modal fade" id="buktiModal" data-bs-keyboard="true" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<legend class="modal-title">Bukti Transfer</legend>
						<button type="button" id="tutupLihatBukti" class="btn-close" data-bs-dismiss="modal"></button>
					</div>
					<div class="modal-body">
						<img v-if="formEdit.previewBuktiBayar" :src="formEdit.previewBuktiBayar" class="w-100" alt="Preview" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from "bootstrap";
import { debounce } from "lodash";
import WebSocketService from "@/components/WebSocketService";
import { createPopper } from "@popperjs/core";
export default {
	name: "DataPembayaran",
	data() {
		return {
			insertListener: (d) => {
				const insert = JSON.parse(d);
				if (this.ta.tahun_ajaran_id == insert.tahun_ajaran_id) {
					this.getDataPembayaran(1);
				}
			},
			updateListener: (d) => {
				const update = JSON.parse(d);

				for (const i of this.dataPembayaran) {
					if (i.bayar_ppdb_id == update.bayar_ppdb_id) {
						if (this.dataAwal.bayar_ppdb_id == update.bayar_ppdb_id) {
							document.getElementById("tutupFormEdit").click();
						}
						this.getDataPembayaran(2);
						break;
					}
				}
			},
			deleteListener: (d) => {
				const del = JSON.parse(d);
				if (this.ta.tahun_ajaran_id == del.tahun_ajaran_id) {
					if (this.pageCurrent == this.pageCount && this.pageCurrent > 1) {
						if (this.dataPembayaran.length == 1) {
							this.pageCurrent = 1;
						} else {
							this.getDataPembayaran(1);
						}
					} else {
						this.getDataPembayaran(1);
					}
				}
			},
			updateKeuanganListener: () => {
				this.getlistKeuangan();
			},
			adminKhusus: false,
			listTa: [],
			listKeuangan: [],
			listTeller: [],
			dataPembayaran: [],
			ta: this.$store.getters.getTahunAjaran,
			key: null,
			petugas_keuangan: null,
			teller: null,
			arrayLimit: [10, 25, 50, 100, 250],
			count: 0,
			pageCurrent: 1,
			pageOffset: 0,
			pageLimit: this.$store.getters.getDefaultLimit,
			pageCount: 0,
			sedangMengunggah: false,
			dataAwal: {},
			formEdit: {
				nominal: null,
				input_nominal: null,
				jenis_bayar: null,
				petugas_keuangan: null,
				sedangInputBukti: false,
				fileTemp: null,
				fileBuktiBayar: null,
				previewTemp: null,
				previewBuktiBayar: null,
			},
		};
	},
	computed: {
		token() {
			return this.$store.getters.getToken;
		},
		taAktif() {
			return this.$store.getters.getTahunAjaran;
		},
		user() {
			return this.$store.getters.getUserData;
		},
	},
	mounted() {
		this.adminKhusus = String(this.user.ket)
			.split(",")
			.some((k) => {
				return ["it", "ppdb-khusus"].includes(k);
			});
		this.getListTa();
		this.getDataPembayaran(0);
		this.getListKeuangan();
		this.getListTeller();
		WebSocketService.on("inserted-keuangan", this.updateKeuanganListener);
		WebSocketService.on("updated-keuangan", this.updateKeuanganListener);
		WebSocketService.on("deleted-keuangan", this.updateKeuanganListener);
		WebSocketService.on("inserted-pembayaran", this.insertListener);
		WebSocketService.on("updated-pembayaran", this.updateListener);
		WebSocketService.on("deleted-pembayaran", this.deleteListener);
	},
	watch: {
		ta() {
			if (this.pageCurrent == 1) {
				this.getDataPembayaran(1);
			} else {
				this.pageCurrent = 1;
			}
		},
		petugas_keuangan() {
			if (this.pageCurrent == 1) {
				this.getDataPembayaran(1);
			} else {
				this.pageCurrent = 1;
			}
		},
		teller() {
			if (this.pageCurrent == 1) {
				this.getDataPembayaran(1);
			} else {
				this.pageCurrent = 1;
			}
		},
		pageCurrent() {
			this.pageOffset = (this.pageCurrent - 1) * this.pageLimit;
			this.getDataPembayaran(1);
		},
		pageLimit() {
			if (this.pageCurrent == 1) {
				this.getDataPembayaran(1);
			} else {
				this.pageCurrent = 1;
			}
		},
		"formEdit.input_nominal"(newValue) {
			let input = new String(newValue).replace(/[^,\d]/g, "");
			const formattedValue = new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				maximumFractionDigits: 0,
			}).format(input);
			this.formEdit.input_nominal = formattedValue;
			this.formEdit.nominal = new Number(input);
		},
		"formEdit.jenis_bayar"(val) {
			if (val === "transfer") {
				const pkTemp = this.listKeuangan.filter((pk) => pk.transfer);
				this.formEdit.petugas_keuangan = pkTemp.length ? pkTemp[0] : null;
				this.formEdit.fileBuktiBayar = this.formEdit.fileTemp;
				this.formEdit.previewBuktiBayar = this.formEdit.previewTemp;
				return;
			}
			this.formEdit.petugas_keuangan = null;
			this.formEdit.fileBuktiBayar = null;
			this.formEdit.previewBuktiBayar = null;
		},
	},
	beforeUnmount() {
		WebSocketService.off("inserted-keuangan", this.updateKeuanganListener);
		WebSocketService.off("updated-keuangan", this.updateKeuanganListener);
		WebSocketService.off("deleted-keuangan", this.updateKeuanganListener);
		WebSocketService.off("inserted-pembayaran", this.insertListener);
		WebSocketService.off("updated-pembayaran", this.updateListener);
		WebSocketService.off("deleted-pembayaran", this.deleteListener);
	},
	methods: {
		lihatBukti() {
			const buktiModal = new Modal(document.getElementById("buktiModal"));
			buktiModal.show();
		},
		withPopper(dropdownList, component, { width }) {
			dropdownList.style.width = width;
			const popper = createPopper(component.$refs.toggle, dropdownList, {
				placement: "bottom",
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [0, -1],
						},
					},
					{
						name: "toggleClass",
						enabled: true,
						phase: "write",
						fn({ state }) {
							component.$el.classList.toggle("drop-up", state.placement === "top");
						},
					},
				],
			});
			return () => popper.destroy();
		},
		search: debounce(function () {
			if (this.pageCurrent == 1) {
				this.getDataPembayaran(1);
			} else {
				this.pageCurrent = 1;
			}
		}, 500),
		async getListTa() {
			try {
				const response = await this.axios.post(
					"/list/tahun-ajaran",
					{},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listTa = response.data.tahun_ajaran;
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async getListTeller() {
			try {
				const response = await this.axios.post(
					"/list/teller",
					{},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listTeller = response.data.teller;
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async getDataPembayaran(n) {
			let memuat;
			if (n != 2) {
				memuat = this.$loading.show({
					container: this.$refs.dataPembayaran,
					loader: n ? "dots" : "spinner",
				});
			}
			try {
				const response = await this.axios.post(
					"/data/pembayaran",
					{
						tahun_ajaran_id: this.ta.tahun_ajaran_id,
						limit: this.pageLimit,
						offset: this.pageOffset,
						key: this.key,
						petugas_keuangan_id: Object(this.petugas_keuangan).petugas_keuangan_id,
						created_by: Object(this.teller).user_id,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.dataPembayaran = response.data.pembayaran;
					for (const i of this.dataPembayaran) {
						i.created_at = new Date(i.created_at).toLocaleString("id-ID");
						if (i.updated_at) {
							i.updated_at = new Date(i.updated_at).toLocaleString("id-ID");
						}
					}
					this.count = response.data.count;
					this.pageCount = Math.ceil(this.count / this.pageLimit);
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
			if (n != 2) {
				setTimeout(() => {
					memuat.hide();
				}, 250);
			}
		},
		async getDataPembayaranEdit(data, modal) {
			const openModal = new Modal(document.getElementById(modal));
			if (data.dataAwal) {
				openModal.show();
				return;
			}
			try {
				const response = await this.axios.post("/data/pembayaran", { bayar_ppdb_id: data.bayar_ppdb_id }, { headers: { Authorization: this.token } });
				if (response.data) {
					const temp = response.data.pembayaran[0];
					let fileTemp = null;
					if (temp.foto_bukti) {
						const base64Data = temp.foto_bukti.replace(/^data:.+;base64,/, "");
						const byteCharacters = atob(base64Data);
						const byteNumbers = new Array(byteCharacters.length);

						for (let i = 0; i < byteCharacters.length; i++) {
							byteNumbers[i] = byteCharacters.charCodeAt(i);
						}

						const byteArray = new Uint8Array(byteNumbers);
						fileTemp = new File([byteArray], "bukti-sebelumnya.jpg", { type: "image/jpeg" });
					}

					this.formEdit = {
						nominal: temp.nominal,
						input_nominal: temp.nominal,
						jenis_bayar: temp.foto_bukti ? "transfer" : "tunai",
						petugas_keuangan: this.listKeuangan.filter((k) => k.petugas_keuangan_id == temp.petugas_keuangan_id)[0],
						sedangInputBukti: false,
						fileTemp: fileTemp,
						fileBuktiBayar: fileTemp,
						previewTemp: temp.foto_bukti,
						previewBuktiBayar: temp.foto_bukti,
					};
					this.dataAwal = temp;
					data.dataAwal = temp;
					openModal.show();
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async handleInputBukti(event) {
			this.sedangInputBukti = true;
			const file = event.target.files[0];
			if (file && file.type.startsWith("image/")) {
				const maxFileSizeMB = 2;
				const maxFileSizeByte = maxFileSizeMB * 1024 * 1024;
				if (file.size > maxFileSizeByte) {
					this.formEdit.sedangInputBukti = false;
					return this.$swal({
						title: "Peringatan",
						text: `Ukuran file tidak boleh melebihi ${maxFileSizeMB}MB!`,
						icon: "warning",
						confirmButtonText: "Mengerti",
					}).then(() => {
						this.$refs.fieldBuktiBayar.value = null;
					});
				}
				this.formEdit.fileBuktiBayar = file;
				setTimeout(() => {
					this.formEdit.previewBuktiBayar = URL.createObjectURL(file);
					this.formEdit.sedangInputBukti = false;
				}, 250);
			} else {
				this.$swal({
					title: "Peringatan",
					text: "File yang Anda pilih bukan file Gambar. Silakan pilih jenis file yang sesuai!",
					icon: "warning",
					confirmButtonText: "Mengerti",
				}).then(() => {
					this.$refs.fieldBuktiBayar.value = null;
					this.formEdit.fileBuktiBayar = null;
					this.formEdit.previewBuktiBayar = null;
					this.formEdit.sedangInputBukti = false;
				});
			}
		},
		async getListKeuangan() {
			try {
				const response = await this.axios.post(
					"/list/keuangan",
					{},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listKeuangan = response.data.keuangan;
					if (this.petugas_keuangan) {
						let ditemukan = 0;
						for (const k of this.listKeuangan) {
							if (this.petugas_keuangan.petugas_keuangan_id == k.petugas_keuangan_id) {
								ditemukan++;
								this.petugas_keuangan = k;
							}
						}
						if (!ditemukan) {
							this.petugas_keuangan = null;
						}
					}
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		cetak(d) {
			const routeCetak = this.$router.resolve({
				path: "/cetak/pembayaran/" + d.ppdb_id,
			});
			window.open(routeCetak.href, "_blank");
		},
		async updateData() {
			let memuat = this.$loading.show({
				container: this.$refs.formEditPembayaran,
				loader: "spinner",
			});
			let dataSama =
				Number(this.formEdit.nominal) === Number(this.dataAwal.nominal) &&
				this.formEdit.petugas_keuangan?.petugas_keuangan_id === this.dataAwal.petugas_keuangan_id &&
				this.formEdit.previewBuktiBayar === this.dataAwal.foto_bukti;
			if (dataSama) {
				this.$swal({
					title: "Perhatian",
					text: "Anda belum melakukan perubahan!",
					icon: "info",
					showConfirmButton: true,
				});
			} else {
				const formData = new FormData();
				formData.append("bayar_ppdb_id", this.dataAwal.bayar_ppdb_id);
				formData.append("nominal", this.formEdit.nominal);
				formData.append("petugas_keuangan_id", this.formEdit.petugas_keuangan?.petugas_keuangan_id);
				formData.append("bukti_bayar", this.formEdit.fileBuktiBayar);
				try {
					const response = await this.axios.post("/pembayaran/perbarui", formData, {
						headers: { Authorization: this.token, "Content-Type": "multipart/form-data" },
					});
					if (response.data) {
						this.$swal({
							title: "Sukses",
							text: response.data.message,
							icon: "success",
							showConfirmButton: false,
							timer: 1500,
						}).then(() => {
							this.cetak(this.dataAwal);
						});
					}
				} catch (err) {
					if (err.response) {
						if (err.response.status == 401) {
							this.$swal({
								title: "Gagal",
								text: "Sesi berakhir. Silakan login ulang.",
								icon: "error",
								confirmButtonText: "Baik",
							}).then(() => {
								this.$store.dispatch("logoutUser");
								window.location.href = this.$sso + "/" + this.$appId;
							});
						} else {
							console.log(err);
							this.$swal({
								title: "Gagal",
								html: `<p class="text-danger">${err.response.data.error}</p>
				  <code class="text-secondary text-bg-secondary bg-opacity-10">code: ${err.response.data.code}<br/>
				  message: ${err.response.data.message}</code>`,
								icon: "error",
								confirmButtonText: "Baik",
							});
						}
					} else {
						console.log(err);
					}
				}
			}
			setTimeout(() => {
				memuat.hide();
			}, 250);
		},
		confirmDelete(d) {
			this.$swal({
				title: "Konfirmasi",
				html: `<span class="h5">Anda yakin ingin menghapus data Pembayaran <code class="text-black text-bg-secondary bg-opacity-50">${d.nama}</code>?</span><br/>
          <small class="fst-italic text-muted">Tindakan ini tidak dapat diurungkan</small>`,
				icon: "question",
				showCancelButton: true,
				confirmButtonText: "Ya, Hapus",
				cancelButtonText: "Batal",
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteData(d);
				}
			});
		},
		async deleteData(d) {
			let memuat = this.$loading.show({
				opacity: 0,
				loader: "spinner",
			});
			try {
				const response = await this.axios.post(
					"/pembayaran/hapus",
					{
						tahun_ajaran_id: this.ta.tahun_ajaran_id,
						bayar_ppdb_id: d.bayar_ppdb_id,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.$swal({
						title: "Sukses",
						text: response.data.message,
						icon: "success",
						showConfirmButton: false,
						timer: 1500,
					});
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
						this.$swal({
							title: "Gagal",
							html: `<p class="text-danger">${err.response.data.error}</p>
                <code class="text-secondary text-bg-secondary bg-opacity-10">code: ${err.response.data.code}<br/>
                message: ${err.response.data.message}</code>`,
							icon: "error",
							confirmButtonText: "Baik",
						});
					}
				} else {
					console.log(err);
				}
			}
			setTimeout(() => {
				memuat.hide();
			}, 250);
		},
	},
};
</script>

<style scoped></style>
